"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const GridWrapper = props => {
    const { children } = props;
    return (react_1.default.createElement("div", { style: Object.assign(Object.assign({}, styles.gridWrapper), { marginRight: props.isOneElement === false && !props.noMargin ? 10 : 0, gap: (props === null || props === void 0 ? void 0 : props.columns) > 1 && !props.isDesktopCard ? '12px' : '4px 15px' }) }, children));
};
const styles = {
    gridWrapper: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    },
};
exports.default = GridWrapper;
//# sourceMappingURL=GridWrapper.js.map